import { request } from 'utils/http/api';

export function getSystemStatus() {
  return request({
    method: 'GET',
    url: 'system-info/maintenance-mode',
  }).then((response) => response);
}
